import { action } from 'typesafe-actions';

import { BaseTypes } from './types';

export const setBase64 = (base: string) => action(BaseTypes.SET_BASE64, base);
